import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import CoursesGrid from "../components/marketing/CoursesGrid";
import ContactCTA from "../components/marketing/ContactCTA";
import { useContent } from "../context/ContentContext";

export default function CoursesPage() {
  const { courses } = useContent();
  return (
    <div data-testid="courses-page">
      <PageHeader
        overline="Our Disciplines"
        title={<>Dance <span className="italic gold-gradient-text">courses</span>.</>}
        subtitle="From the sacred geometry of Bharatanatyam to the raw energy of hip hop — find the form that moves you."
        image="https://images.unsplash.com/photo-1621976498727-9e5d56476276?crop=entropy&cs=srgb&fm=jpg&q=85"
      />
      <CoursesGrid courses={courses} heading={false} />
      <ContactCTA />
    </div>
  );
}
